import React from "react";
import "./about.css";
import Me from "../../assets/deepak2.png";
import { FaAward, FaCertificate, FaFolder} from "react-icons/fa";

const About = () => {
  return (
    <section id="about">
      <h5>Get to Know </h5>
        <h2>About Me</h2>
      <div className="container about_container">
        <div className="about_me " data-aos="zoom-out-right">
          <div className="about_me-image">
            <img src={Me} alt="About me" />
          </div>
        </div>
        <div className="about_content " data-aos="zoom-out-left">
          <div className="about_cards">
            <article className="about_card">
              <FaAward className="about_icon" />
              <h5>Experience</h5>
              <small>Fresher</small>
            </article>
            <article className="about_card">
              <FaCertificate className="about_icon" />
              <h5>Certificates</h5>
              <small>2+</small>
            </article>
            <article className="about_card ">
              <a href="#project"> 
              <FaFolder className="about_icon"  />
              </a>
             
              <h5>Projects</h5>
              <small>10+ projects completed</small>
            </article>
          </div>
          <p>I’m a MERN-Stack Developer, who enjoys building interactive  interfaces with JavaScript, React ,Express and MongoDB.
            <br />
            <br />
            I'm Passionate about Coding and building Project.
            <br />
            <br />
            Apart from building only web projects, I also have intrestes in programming languages like Java, C++, Python, C#.
            I have built many programs and projects using these programming languages.
            If you have a project you needed to code, 
            don’t hesitate to contact me.
          </p>
          <a href="#project" className="btn btn-primary"> See My Projects</a>
        </div>
      </div>
    </section>
  );
};

export default About;
